import type {RecentlyTouchedBranch} from '@github-ui/code-view-types'
import React, {useMemo} from 'react'

export interface RecentlyTouchedBranches {
  branches?: RecentlyTouchedBranch[] | null
  channel?: string | null
  canCreatePullRequest?: boolean
}

export interface RecentlyTouchedBranchesContextData extends RecentlyTouchedBranches {
  refetch: () => void
}

const noop = () => {}

const defaultValue: RecentlyTouchedBranchesContextData = {
  branches: null,
  channel: null,
  canCreatePullRequest: true,
  refetch: noop,
}

const RecentlyTouchedBranchesContext = React.createContext<RecentlyTouchedBranchesContextData>(defaultValue)

export function useRecentlyTouchedBranches() {
  return React.use(RecentlyTouchedBranchesContext)
}

export function RecentlyTouchedBranchesProvider({
  branches,
  channel,
  canCreatePullRequest = true,
  refetch,
  children,
}: React.PropsWithChildren<{
  branches?: RecentlyTouchedBranch[] | null
  channel?: string | null
  canCreatePullRequest?: boolean
  refetch: () => void
}>) {
  const value = useMemo(
    () => ({branches, channel, canCreatePullRequest, refetch}),
    [branches, channel, canCreatePullRequest, refetch],
  )

  return <RecentlyTouchedBranchesContext value={value}>{children}</RecentlyTouchedBranchesContext>
}
